module.exports={
  "facebook_parcels": {
    "key": "facebook_parcels",
    "path": "geo/facebook_buffer.json",
    "classNames": "parcels, fb"
  },
  "google_parcels": {
    "key": "google_parcels",
    "path": "geo/google_buffer.json",
    "classNames": "parcels, google"
  },
  "google_parcels_discrete": {
    "key": "google_parcels_discrete",
    "path": "geo/google_parcels.json",
    "classNames": "parcels, google, no-drop"
  },
  "facebook_parcels_faded": {
    "key": "facebook_parcels_faded",
    "path": "geo/facebook_buffer.json",
    "classNames": "parcels, fb, faded, no-drop"
  },
  "facebook_buildings": {
    "key": "facebook_buildings",
    "path": "geo/facebook_buildings.json",
    "classNames": "buildings, fb"
  },
  "facebook_levee": {
    "key": "facebook_levee",
    "path": "geo/fb_levee.json",
    "classNames": "levee"
  },
  "flood50": {
    "key": "flood50",
    "path": "geo/flood_50.json",
    "classNames": "flood, flood-50"
  },
  "flood50_transparent": {
    "key": "flood50_transparent",
    "path": "geo/flood_50.json",
    "classNames": "flood, flood-transparent"
  },
  "flood100": {
    "key": "flood100",
    "path": "geo/flood_100.json",
    "classNames": "flood, flood-100",
    "notes": "flood_100.json"
  },
  "flood100_transparent": {
    "key": "flood100_transparent",
    "path": "geo/flood_100.json",
    "classNames": "flood, flood-transparent"
  },
  "east_palo_alto": {
    "key": "east_palo_alto",
    "path": "geo/east-palo-alto-bounds.json",
    "classNames": "area, east-palo-alto"
  },
  "belle_haven": {
    "key": "belle_haven",
    "path": "geo/bellehaven.geojson",
    "classNames": "area, belle-haven"
  },
  "google_levee": {
    "key": "google_levee",
    "path": "geo/google_levee.json",
    "classNames": "levee, google"
  },
  "roads": {
    "key": "roads",
    "path": "geo/roads_selection.json",
    "classNames": "roads"
  },
  "sunnyvale": {
    "key": "sunnyvale",
    "path": "geo/sunnyvale.geojson",
    "classNames": "parcels, google"
  },
  "sunnyvale_outline": {
    "key": "sunnyvale_outline",
    "path": "geo/sunnyvale_outline.json",
    "classNames": "area, sunnyvale"
  },
  "fb21": {
    "key": "fb21",
    "path": "geo/fb21.geojson",
    "classNames": "fb21"
  },
  "flood_100_levee_clipped": {
    "key": "flood_100_levee_clipped",
    "path": "geo/flood_100_levee_clipped.geojson",
    "classNames": "flood, flood-levee"
  }
}